export class AuctionAuthorizationRequest{

    public id!:number;
    public auctionId!:number;
    public scheduleSeqNo!:number;
    public userId!:string;
    public amount!:number;
    public gatewayReference?:string;
    public gatewayResponse?:string;
    public date!:Date;
    public success:boolean = false;
    public termsAccepted:boolean = false;

    constructor(){
    }
}